import { DeleteFilled } from '@ant-design/icons'
import { IBarcodeWithExtraProps } from 'Services/Kiosk/BarcodeService'

export default function InternalBarcodeCell({
  barcode,
  isDeleteMode,
  onDeleteClick: onEditClick,
}: {
  barcode: IBarcodeWithExtraProps
  isDeleteMode: boolean
  onDeleteClick: (sizename: string, barcode: string) => void
}) {
  function handleOnDeleteClick(sizename: string, barcode: string) {
    onEditClick(sizename, barcode)
  }

  if (barcode) {
    return isDeleteMode ? (
      <span className={barcode.isDeleted ? 'barcode-delete-active' : ''}>
        <DeleteFilled
          className={'generic-icon active'}
          onClick={() => handleOnDeleteClick(barcode.size.sizeName, barcode.value)}
        ></DeleteFilled>
        {barcode.value}
      </span>
    ) : (
      <span className={barcode.isDeleted ? 'barcode-delete-active' : ''}>{barcode.value}</span>
    )
  }

  return null
}
